<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Firstname</v-list-item-subtitle>
              <v-list-item-title>{{ this.model.client.firstname }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Customer Email</v-list-item-subtitle>
              <v-list-item-title>{{ this.model.client.email }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="6">
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Lastname</v-list-item-subtitle>
              <v-list-item-title>{{ this.model.client.lastname }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Mobile Phone</v-list-item-subtitle>
              <v-list-item-title>{{ this.model.client.mobile }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <order-address
          label="Billing Address"
          :value="this.model.billingAddress"
          :orderId="this.model.id"
          :customerId="this.model.clientId"
          type="billing"
          @updated="update()"
        />
      </v-col>
      <v-col cols="6">
        <order-address
          label="Shipping Address"
          :value="this.model.shippingAddress"
          :orderId="this.model.id"
          :customerId="this.model.clientId"
          type="shipping"
          @updated="update()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrderAddress from "@components/orders/OrderAddress.vue";
export default {
  components: {
    OrderAddress,
  },
  props: ["order"],
  computed: {
    model () {
      return this.order
    },
    isDisabled: function() {
      //if (this.model.statusId == "close" ||this.model.statusId == "cancel") return true;
      return false;
    },
  },
  methods: {
    update: function() {
      this.$emit("updated");
    },
  },
};
</script>
